export const TERMS_NOTICE_VERSION = "2026-03-16";
export const TERMS_NOTICE_ANNOUNCED_DATE = "2026년 3월 7일";
export const TERMS_NOTICE_EFFECTIVE_DATE = "2026년 3월 14일";
export const TERMS_NOTICE_TARGET_SIGNUP_BEFORE = "2026-03-07T00:00:00+09:00";
